import { blockCategories } from '../../categories';

export default function (editor, opts = {}) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType('div', {
        model: {
            defaults: {
                tagName: 'div',
                droppable: true,
                draggable: true,
                stylable: true,
                attributes: {
                    class:"sio-div",
                },
                style: {

                },
            },
        },
        view: {},
    });


    blockManager.add('div', {
        label: 'Div',
        category: blockCategories.layout,
        media: `<svg viewBox="0 0 24 24">
        <path  width="24" height="24" fill="currentColor" d="M2 20h20V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1Z"/>
      </svg>`,
        content: {
            type: 'div',
        },
    });
}
